const formatter = {
    methods: {
        currency: function (value) {
            return 'R$ ' + parseFloat(value).toFixed(2).toString().replace('.', ',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
        }
    }
}

export default formatter